<script setup lang="ts">
// useHead({
//   link: [
//     {
//       rel: 'preload',
//       as: 'video',
//       href: '/video/banner-benefits.mp4',
//       type: 'video/mp4',
//       fetchpriority: 'high',
//     },
//   ],
// });

const route = useRoute();
// const modalStore = useModalsStore();

const bannerMap = {
  'default': {
    img: '/img/new/banner/faragir-plan.gif',
    link: '/products/cloud-pbx/'
  },
  'shopping': {
    img: '/img/new/banner/campaign-01.jpg',
    link: ''
  },
} as const;

const activeBanner = computed((): keyof typeof bannerMap => {
  if (!route.path) return 'default';
  if (route.path.startsWith('/online-shopping')) return 'shopping';
  return 'default';
});

// function handleOnClick() {
//   modalStore.openModal('CTA');
// };
</script>

<template>
    <div v-show="activeBanner === 'shopping'" class="w-full h-8 lg:h-16">
      <NuxtLink 
        :to="bannerMap[activeBanner].link" 
        class="w-full h-full"
      >
        <img
          :src="bannerMap[activeBanner].img"
          alt="مرکز تلفن ابری"
          class="w-full h-full object-cover"
          :preload="{ fetchPriority: 'high' }"
          fetchpriority="high"
          loading="eager"
        />
      <!-- <div class="cursor-pointer w-full h-full" @click="handleOnClick">
        <video
          class="w-full h-full object-cover pointer-events-none"
          autoplay
          muted
          loop
          playsinline
          preload="auto"
          disablepictureinpicture
          controlslist="nodownload noplaybackrate"
          translate="no"
          aria-hidden="true"
        >
          <source 
            src="/video/banner-benefits.mp4" 
            type="video/mp4" 
            class="w-full h-16" 
          />
        </video>
      </div> -->
      </NuxtLink>
    </div>
</template>